/**
 * The full fermentable collection, assembled from the per-supplier files.
 *
 * Order is supplier-by-supplier rather than alphabetical: the files are the
 * unit of maintenance, and a stable order makes diffs readable.
 */

import type { Fermentable } from '../../schema/fermentable';
import { australianFermentables } from './australia';
import { avangardFermentables } from './avangard';
import { belgianFermentables } from './belgium';
import { bestmalzFermentables } from './bestmalz';
import { canadaMaltingFermentables } from './canada-malting';
import { craftMalthouseFermentables } from './craft/index';
import { czechFermentables } from './czech';
import { frenchAndJuppsFermentables } from './french-and-jupps';
import { gambrinusFermentables } from './gambrinus';
import { genericFermentables } from './generic';
import { ireksFermentables } from './ireks';
import { irishFermentables } from './ireland';
import { malteuropFermentables } from './malteurop';
import { mfbFermentables } from './mfb';
import { northAmericanFermentables } from './north-america';
import { prairieMaltFermentables } from './prairie-malt';
import { proximityFermentables } from './proximity';
import { swaenFermentables } from './swaen';
import { ukFermentables } from './uk';
import { vikingGladfieldFermentables } from './viking-gladfield';
import { warminsterFermentables } from './warminster';
import { weyermannFermentables } from './weyermann';

export { australianFermentables } from './australia';
export { avangardFermentables } from './avangard';
export { belgianFermentables } from './belgium';
export { bestmalzFermentables } from './bestmalz';
export { canadaMaltingFermentables } from './canada-malting';
export { craftMalthouseFermentables } from './craft/index';
export { czechFermentables } from './czech';
export { frenchAndJuppsFermentables } from './french-and-jupps';
export { gambrinusFermentables } from './gambrinus';
export { genericFermentables } from './generic';
export { ireksFermentables } from './ireks';
export { irishFermentables } from './ireland';
export { malteuropFermentables } from './malteurop';
export { mfbFermentables } from './mfb';
export { northAmericanFermentables } from './north-america';
export { prairieMaltFermentables } from './prairie-malt';
export { proximityFermentables } from './proximity';
export { swaenFermentables } from './swaen';
export { ukFermentables } from './uk';
export { vikingGladfieldFermentables } from './viking-gladfield';
export { warminsterFermentables } from './warminster';
export { weyermannFermentables } from './weyermann';

/** Every fermentable in the catalog. */
export const fermentables: readonly Fermentable[] = [
  ...weyermannFermentables,
  ...bestmalzFermentables,
  ...ireksFermentables,
  ...avangardFermentables,
  ...belgianFermentables,
  ...mfbFermentables,
  ...ukFermentables,
  ...irishFermentables,
  ...warminsterFermentables,
  ...frenchAndJuppsFermentables,
  ...northAmericanFermentables,
  ...proximityFermentables,
  ...canadaMaltingFermentables,
  ...prairieMaltFermentables,
  ...gambrinusFermentables,
  ...malteuropFermentables,
  ...vikingGladfieldFermentables,
  ...australianFermentables,
  ...czechFermentables,
  ...craftMalthouseFermentables,
  ...genericFermentables,
  ...swaenFermentables,
];
